import { constants, Yup } from 'cng-web-lib'
import SCOInvMgmtKeys from 'src/constants/locale/key/SCOInvMgmt'
import Namespace from 'src/constants/locale/Namespace'
import { makeAddressValidationSchema } from '../common/makeAddressValidationSchema'

const {
	locale: {
		key: {
			CommonValidationMessageKeys,
		},
	},
} = constants

const FIELDS_MAX_LENGTH = {
	BUYER_NAME: 255,
}

export function makeValidationSchema(translate) {
	let requiredMessage = translate(Namespace.COMMON_VALIDATION_MSG, CommonValidationMessageKeys.REQUIRED)
	let exceedCharMsg = translate(Namespace.SCO_INV_MGMT, SCOInvMgmtKeys.EXCEED_CHAR_LIMIT_MSG)

	return Yup.object({
		buyerName: Yup.string().nullable().required(requiredMessage).max(FIELDS_MAX_LENGTH.BUYER_NAME, exceedCharMsg),
		address: makeAddressValidationSchema(translate)
	})
}

